import React from 'react'
import styled from 'styled-components'
import rem from 'polished/lib/helpers/rem'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { useAppSelector } from 'hooks/reduxHooks'
import HighIntentOffersCarousel from 'components/OfferList/HighIntent/HighIntentOffersCarousel'
import { getHighIntentOffers } from 'selectors/recomendations/highIntentSelectors'
import config from 'constants/config'

const Section = styled(Pane)`
  padding: ${rem(16)} 0;
`

function FrontPageHighIntentOffers() {
  const highIntentOffers = useAppSelector(getHighIntentOffers)

  const hasOffers = highIntentOffers.length > 0

  if (!hasOffers || !config.LERE_HIGH_INTENT_CAROUSEL_ENABLED) {
    return null
  }

  return <Section>
    <LayoutContainer>
      <VerticalSpacer gap={12}>
        <BodyText variant="medium" weight="bold">Still interested in these offers?</BodyText>
        <HighIntentOffersCarousel
          highIntentOffers={highIntentOffers}
          analyticsLabel="all offers"
        />
      </VerticalSpacer>
    </LayoutContainer>
  </Section>
}

export default FrontPageHighIntentOffers
